import { Box, Flex, Input, useColorModeValue } from "@chakra-ui/react";
import React from "react";
import { Link } from "react-router-dom";
import { IoSearchCircleOutline } from "react-icons/io5";
import { useLanguage } from "../../context/LanguageContext";

const TeacherNavTop = ({ handleSearch }) => {
  const { t } = useLanguage();

  return (
    <Flex h="8vh" justifyContent={"space-between"} mt="5px" mb="15px">
      <Flex w={{ base: "100%", md: "60%" }} align="center">
        <Link>
          <IoSearchCircleOutline
            style={{ fontSize: "5vh", color: "gray", marginTop: "3px", marginRight: "10px" }}
          />
        </Link>
        <Box w="100%">
          <Input
            placeholder={t("Search Anything")}
            border={"1px solid var(--border-soft)"}
            borderRadius="full"
            h={"6vh"}
            w="100%"
            onChange={handleSearch}
            bg={useColorModeValue("white", "gray.800")}
          />
        </Box>
      </Flex>
    </Flex>
  );
};

export default TeacherNavTop;
